import { render, staticRenderFns } from "./NewspapersDetais.vue?vue&type=template&id=fe185640&scoped=true&"
import script from "./NewspapersDetais.vue?vue&type=script&lang=js&"
export * from "./NewspapersDetais.vue?vue&type=script&lang=js&"
import style0 from "./NewspapersDetais.vue?vue&type=style&index=0&id=fe185640&lang=less&scoped=true&"
import style1 from "./NewspapersDetais.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe185640",
  null
  
)

export default component.exports